import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import illu from "./../../assets/images/illu/Business.png";

const Service = () => {
  return (
    <section className="Service-container" id="services">
      <img className="img-illu" src={illu} alt="illustration" />
      <article className="Service-text">
        <ul>
          <li>
            <h2 className="grey">Innovation</h2>
          </li>
          <li>
            <h2 className="blue">Expertise</h2>
          </li>
          <li>
            <h2 className="grey">Proximité</h2>
          </li>
          <li>
            <h2 className="blue">Accessibilité</h2>
          </li>
          <li>
            <h2 className="grey last-title">Sérénité</h2>
          </li>
        </ul>
        <p>
          Chez JPP COMPTA, on transforme la gestion comptable en un outil
          puissant (et accessible) pour entrepreneurs ambitieux.
          <br /> Vous êtes freelance, startup ou une petite boîte qui démarre ?
          <br />
          <br /> Laissez-nous vous accompagner pour que vos chiffres travaillent
          aussi dur que vous.
        </p>
        <Link to="#contact" className="btn">
           Parlons chiffres <svg xmlns="http://www.w3.org/2000/svg" className="arrow-icon white" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
        </Link>
      </article>
    </section>
  );
};

export default Service;
